'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Control = require('../Control');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var refCount = 0;

var RadioGroup = function (_Component) {
  (0, _inherits3.default)(RadioGroup, _Component);

  function RadioGroup() {
    (0, _classCallCheck3.default)(this, RadioGroup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RadioGroup.__proto__ || (0, _getPrototypeOf2.default)(RadioGroup)).call(this));

    _this._name = '_radio-group-' + ++refCount + '_';
    return _this;
  }

  (0, _createClass3.default)(RadioGroup, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$options = _props.options,
          options = _props$options === undefined ? [] : _props$options,
          name = _props.name,
          value = _props.value,
          _onChange = _props.onChange,
          props = (0, _objectWithoutProperties3.default)(_props, ['options', 'name', 'value', 'onChange']);

      return options.map(function (option) {
        return _react2.default.createElement(_Control.Radio, (0, _extends3.default)({}, props, option, {
          name: name || _this2._name,
          key: option.value,
          value: value == option.value,
          onChange: function onChange() {
            return _onChange(option.value);
          },
          label: option.label
        }));
      });
    }
  }]);
  return RadioGroup;
}(_react.Component);

exports.default = RadioGroup;